import {
    useMutation,
    useQuery,
} from '@tanstack/react-query'
import axios from 'axios'
import { useAuthContext } from 'context/authContext'

enum ISchoolsSlugs {
    lmc = 'LMC',
    test = 'TEST'
}

interface IUser {
    id: number
    username: string
    email: string
    provider: string
    confirmed: boolean
    blocked: boolean
    createdAt: string
    updatedAt: string
}

interface IAuthResponse {
    jwt: string
    user: IUser
}

interface ILoginVariables {
    identifier: string
    password: string
}

interface ISchoolInfo {
    name_zh: string,
    name_en: string,
    logo: {
        url: string
    },
    slug: ISchoolsSlugs
}

interface IMeResponse extends IUser {
    school_info: ISchoolInfo
}

export const useAuth = () => {
    const { login, isLoggedIn } = useAuthContext()
    const loginMutation = useMutation({
        mutationKey: ['auth', 'login'], // More descriptive mutation key
        mutationFn: async ({ identifier, password }: ILoginVariables) => {
            axios.defaults.headers.common['Authorization'] = ''
            const loginResult = await axios.post<IAuthResponse>('/api/auth/local', {
                identifier,
                password,
            })

            // Store the JWT in localStorage or a similar mechanism
            if (loginResult.data.jwt) {
                login(loginResult.data.jwt)
                localStorage.setItem('token', loginResult.data.jwt)
            }

            return loginResult.data
        },
    })

    const me = useQuery<IMeResponse | null>({
        queryKey: ['auth', 'me'],
        queryFn: async () => {
            const result = await axios.get<IMeResponse>('/api/users/me', {
                params: {
                    populate: 'school_info.logo'
                }
            })
            return result.data
        },
        enabled: isLoggedIn,
    })

    return { login: loginMutation, me } // Renamed to login for consistency
}